const getScaledWidth = shape => shape.get('scaleX', 1) * shape.get('width');

const getScaledHeight = shape => shape.get('scaleY', 1) * shape.get('height');

export {
    getScaledWidth,
    getScaledHeight
};
